export default __webpack_public_path__ + "static/media/110年行事曆.ddbe7950.png";